/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Ev_InboxInputs */

const en_fw_notify_ev_inbox = /** @type {(inputs: Fw_Notify_Ev_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something is waiting for you (inbox)`)
};

const id_fw_notify_ev_inbox = /** @type {(inputs: Fw_Notify_Ev_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada yang menunggu Anda (inbox)`)
};

/**
* | output |
* | --- |
* | "Something is waiting for you (inbox)" |
*
* @param {Fw_Notify_Ev_InboxInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_ev_inbox = /** @type {((inputs?: Fw_Notify_Ev_InboxInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Ev_InboxInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_ev_inbox(inputs)
	return en_fw_notify_ev_inbox(inputs)
});